import { z } from "zod";
import { SpotifyIdSchema } from "./common.ts";

export const GraphMapNodeSchema = z.object({
  id: SpotifyIdSchema,
  name: z.string().nullable(),
  image_url: z.string().nullable(),
  track_count: z.number().int().nonnegative(),
  x: z.number(),
  y: z.number(),
  component: z.number().int(),
  is_orphan: z.boolean(),
  genre_id: z.string().nullable().optional(),
  genre_name: z.string().nullable().optional(),
  genre_color: z.string().nullable().optional(),
  genre_source: z.enum(["user", "spotify"]).nullable().optional(),
});
export type GraphMapNode = z.infer<typeof GraphMapNodeSchema>;

export const GraphMapEdgeSchema = z.object({
  a: SpotifyIdSchema,
  b: SpotifyIdSchema,
  weight: z.number(),
  shared_count: z.number().int(),
  track_shared: z.number().int(),
  album_shared: z.number().int(),
  /** Strongest link: track if any shared tracks, else album-only. */
  kind: z.enum(["track", "album"]),
});
export type GraphMapEdge = z.infer<typeof GraphMapEdgeSchema>;

export const GraphMapSchema = z.object({
  nodes: z.array(GraphMapNodeSchema),
  edges: z.array(GraphMapEdgeSchema),
  bounds: z.object({
    min_x: z.number(),
    max_x: z.number(),
    min_y: z.number(),
    max_y: z.number(),
  }),
  genre_source_in_play: z.enum(["user", "spotify", "mixed", "none"]),
  laid_out_at: z.string().nullable(),
});
export type GraphMap = z.infer<typeof GraphMapSchema>;

/** Neighbour ids at graph distance 1 for focus/hover. */
export const GraphNeighbourhoodSchema = z.object({
  artist_id: SpotifyIdSchema,
  neighbour_ids: z.array(SpotifyIdSchema),
});
export type GraphNeighbourhood = z.infer<typeof GraphNeighbourhoodSchema>;

export const ArtistPositionRowSchema = z.object({
  artist_id: SpotifyIdSchema,
  x: z.number(),
  y: z.number(),
  component: z.number().int(),
  is_orphan: z.union([z.boolean(), z.literal(0), z.literal(1)]).transform((v) => v === true || v === 1),
  laid_out_at: z.string(),
});
